import { render, staticRenderFns } from "./HardwareShopBadge.vue?vue&type=template&id=5825e092&"
import script from "./HardwareShopBadge.vue?vue&type=script&lang=js&"
export * from "./HardwareShopBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports